export default __webpack_public_path__ + "static/media/image7.3818354c.jpg";